import { QueryTransformer } from './query-transformer';
import { TransformedQuery } from './transformed-query';

/**
 * represents a chain of QueryTranformers
 */
export class QueryTransformerChain implements QueryTransformer {
  protected queryTransformers: QueryTransformer[] = [];

  /**
   * iterating over the parts of the chain to transform the query.
   * @param query
   */
  transform(query: TransformedQuery): TransformedQuery {
    let returnQuery = query;
    this.queryTransformers.forEach((item) => {
      returnQuery = item.transform(returnQuery);
    });
    return returnQuery;
  }

  /**
   * add a new QueryTransformer to end of the chain.
   * @param queryTransformer
   */
  public add(queryTransformer: QueryTransformer): QueryTransformerChain {
    this.queryTransformers.push(queryTransformer);
    return this;
  }
}
